import PlaceIcon from '@mui/icons-material/Place';

export default PlaceIcon;
